//Will sanitize the html to prevent XSS attacks
//Use this as element with html prompt (type is string)

import React from 'react';
import DOMPurify from "isomorphic-dompurify";

interface SafeHtmlProps extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
    html: string;
}

const SafeHtml: React.FC<SafeHtmlProps> = ({ html, ...props }) => {
    const sanitized = DOMPurify.sanitize(html);

    return (
        <div
            dangerouslySetInnerHTML={{ __html: sanitized }}
            {...props}
        />
    )
}

export default SafeHtml;
